export const arrayToMap = (arr, key = 'id') => {
  return Object.fromEntries(arr.map(o => [o[key], o]));
};

export const _times = (count, func) => {
    // Проверяем, что func — функция
    if (typeof func !== 'function') {
        func = () => {};
    }

    // Проверяем count
    if (typeof count !== 'number' || count <= 0) {
        return [];
    }

    // Создаём массив индексов и применяем func
    return Array.from({ length: count }, (_, i) => func(i));
};
export const createArray = (count, template = null) => {
  const arr = [];
  if (typeof count === 'number' && count) {
    for (let i = 0; i < count; ++i) {
      arr.push(template !== null && typeof template === 'object' ? { ...template } : template);
    }
  }

  return arr;
};

export const isMediaDevicesSupported = () => {
  const isMediaDevicesSupported = typeof navigator !== "undefined" && !!navigator.mediaDevices;

  if (!isMediaDevicesSupported) {
    console.warn(`[ReactQrReader]: MediaDevices API has no support for your browser. You can fix this by running "npm i webrtc-adapter"`);
  }

  return isMediaDevicesSupported;
};

export const isValidType = (value, name, type) => {
  const isValid = typeof value === type;

  if (!isValid) {
    console.warn(`[ReactQrReader]: Expected "${name}" to be a of type "${type}".`);
  }

  return isValid;
};


export const env = (name, defValue) => {
  const env = { ...process.env, ...window['env'] }
  let value = name instanceof Array ? name.find((n) => env[n] !== undefined) : env[name];

  if (value === '') {
    value = '';
  } else if (typeof value === 'string' && value.toLocaleLowerCase() === 'true') {
    value = true;
  } else if (typeof value === 'string' && value.toLocaleLowerCase() === 'false') {
    value = false;
  } else if (typeof value === 'string' && !isNaN(Number(value))) {
    value = Number(value);
  } else if (value === undefined) {
    value = defValue;
  }

  return value;
};



export const getInnerText = (obj) => {
  let buf = '';

  if (obj) {
    let type = typeof(obj);

    if (type === 'string' || type === 'number') {
      buf += obj;
    } else if (type === 'object') {
      let children = null;

      if (Array.isArray(obj)) {
        children = obj;
      } else {
        let props = obj.props;
        if (props) {
          children = props.children;
        }
      }

      if (children) {
        if (Array.isArray(children)) {
          children.forEach(function(o) {
            buf += getInnerText(o);
          });
        } else {
          buf += getInnerText(children);
        }
      }
    }
  }
  return buf;
};

export const capitalize = s => s && String(s[0]).toUpperCase() + String(s).slice(1).toLowerCase();

export const getNumber = (value, defaultValue = '') => {
  let num = defaultValue;

  if (typeof value === 'number') {
    num = value;
  } else if (typeof value === 'string') {
    num = Number(value);
    if (isNaN(num)) {
      num = defaultValue;
    }
  }

  return num;
};

export const arrayEquals = (a1, a2) => {
  if (a1 === a2) return true;
  if (!(a1 instanceof Array) || !(a2 instanceof Array)) return false;
  if (a1.length !== a2.length) return false;
  return a1.every((a, i) => a === a2[i]);
};
